import {
  fetchGetApiIntroducerPortalIntroducerWhatsNew,
  fetchPostApiIntroducerPortalIntroducerWhatsNew,
} from '@iwoca/lapi-client/introducer_portal';
import { TWhatsNewContent } from 'lendingApi/whatsNew';

type TFormattedWhatsNewPayload = {
  data: TWhatsNewContent[];
  nextPage: number | undefined;
  total?: number;
  pages?: number;
  totalUnseen?: number;
};

export const getWhatsNewContent = async (
  introducerId: string,
  pageNo = 1,
): Promise<TFormattedWhatsNewPayload> => {
  const {
    data: { notifications, next_page, results, pages, unread_notifications },
  } = await (
    await fetchGetApiIntroducerPortalIntroducerWhatsNew({
      introducerId,
      query: {
        //@ts-ignore
        page_no: pageNo,
        per_page: 5,
      },
    })
  ).json();

  const notificationsWithIds = notifications.map((notification: any) => ({
    id: new Date(notification.created).getTime(),
    ...notification,
  }));

  return {
    data: notificationsWithIds,
    nextPage: next_page || undefined,
    total: results,
    totalUnseen: unread_notifications,
    pages,
  };
};

export const markAllWhatsNewContentAsRead = async (introducerId: string) => {
  return await fetchPostApiIntroducerPortalIntroducerWhatsNew({
    introducerId,
    body: {},
  });
};
